import { render, staticRenderFns } from "./node-wrapper.vue?vue&type=template&id=a566015e&"
import script from "./node-wrapper.vue?vue&type=script&lang=js&"
export * from "./node-wrapper.vue?vue&type=script&lang=js&"
import style0 from "../index.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./node-wrapper.vue?vue&type=style&index=1&id=a566015e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports